import { useTheatricalPromotionContext } from '@/views/TicketCheckoutViews/components/TheatricalPromotionContext'
import { CustomImageBanner } from './CustomImageBanner'
import { NoFeesBanner } from './NoFeesBanner'

const noFeesConfig = {
  bannerType: 'no_fees',
  backgroundImage: {
    __typename: 'Asset',
    url: 'https://images.ctfassets.net/4jbwlym6m4be/znGR7G2oybrksMdWaOXPj/e07cb94be8225d4e80c15f9e2826a2dd/kids-go-free-banner-bg.jpeg',
    width: 4240,
    height: 2560,
  },
  foregroundImage: {
    __typename: 'Asset',
    url: 'https://images.ctfassets.net/4jbwlym6m4be/6TpWyapXLSNp37XKKwAif6/2a235a4f29e02ed63c68f381019b62ed/david-film_Young_David_9020s0101-char-v01_copy_1.png',
    width: 864,
    height: 560,
  },
  accentColor: '#EA6F13',
}

const bogoConfig = {
  desktopImage: {
    url: '/v1763771728/david/default-promo/new-banners/David_Black-Friday-Deal-Banners_V2_BOGO_Desktop_2120x280',
    width: 2120,
    height: 280,
  },
  tabletImage: {
    url: '/v1763771724/david/default-promo/new-banners/David_Black-Friday-Deal-Banners_V2_BOGO_Tablet_Mobile_1032x280',
    width: 1032,
    height: 280,
  },
  mobileImage: {
    url: '/v1763771726/david/default-promo/new-banners/David_Black-Friday-Deal-Banners_V2_BOGO_Mobile_792x280',
    width: 792,
    height: 280,
  },
}

const tenDollarConfig = {
  desktopImage: {
    url: '/v1763771753/david/default-promo/new-banners/David_Black-Friday-Deal-Banners_V2__10-TICKETS_Desktop_2120x280',
    width: 2120,
    height: 280,
  },
  tabletImage: {
    url: '/v1763771747/david/default-promo/new-banners/David_Black-Friday-Deal-Banners_V2__10-TICKETS_Tablet_Mobile_1032x280',
    width: 1032,
    height: 280,
  },
  mobileImage: {
    url: '/v1763771750/david/default-promo/new-banners/David_Black-Friday-Deal-Banners_V2__10-TICKETS_Mobile_792x280',
    width: 792,
    height: 280,
  },
}

const familyPack3Config = {
  desktopImage: {
    url: '/v1763771744/david/default-promo/new-banners/David_Black-Friday-Deal-Banners_V2_3-TICKET-FAMILY-PACK_Desktop_2120x280',
    width: 2120,
    height: 280,
  },
  tabletImage: {
    url: '/v1763771739/david/default-promo/new-banners/David_Black-Friday-Deal-Banners_V2_3-TICKET-FAMILY-PACK_Tablet_Mobile_1032x280',
    width: 1032,
    height: 280,
  },
  mobileImage: {
    url: '/v1763771741/david/default-promo/new-banners/David_Black-Friday-Deal-Banners_V2_3-TICKET-FAMILY-PACK_Mobile_792x280',
    width: 792,
    height: 280,
  },
}

const familyPack4Config = {
  desktopImage: {
    url: '/v1763771737/david/default-promo/new-banners/David_Black-Friday-Deal-Banners_V2_4-TICKET-FAMILY-PACK_Desktop_2120x280',
    width: 2120,
    height: 280,
  },
  tabletImage: {
    url: '/v1763771731/david/default-promo/new-banners/David_Black-Friday-Deal-Banners_V2_4-TICKET-FAMILY-PACK_Tablet_Mobile_1032x280',
    width: 1032,
    height: 280,
  },
  mobileImage: {
    url: '/v1763771734/david/default-promo/new-banners/David_Black-Friday-Deal-Banners_V2_4-TICKET-FAMILY-PACK_Mobile_792x280',
    width: 792,
    height: 280,
  },
}

const DavidDefaultPromoBanner = () => {
  const { experiments, publicDiscounts } = useTheatricalPromotionContext()

  const variation = experiments?.['david-default-promo'] ?? 'nofees'

  if (variation === 'nofees') {
    if (!publicDiscounts.noFeesDiscount) return null
    return (
      <NoFeesBanner
        {...noFeesConfig}
        code={publicDiscounts.noFeesDiscount.code}
        noFeesDiscount={publicDiscounts.noFeesDiscount}
        backgroundIsDark={false}
      />
    )
  }

  if (variation === 'bogo') {
    return <CustomImageBanner {...bogoConfig} alt="David Black Friday Deal - BOGO" />
  }

  if (variation === 'ten_dollar') {
    return <CustomImageBanner {...tenDollarConfig} alt="David Black Friday Deal - $10 Tickets" />
  }

  if (variation === 'family_pack_3') {
    return <CustomImageBanner {...familyPack3Config} alt="David Black Friday Deal - 3 Ticket Family Pack" />
  }

  if (variation === 'family_pack_4') {
    return <CustomImageBanner {...familyPack4Config} alt="David Black Friday Deal - 4 Ticket Family Pack" />
  }

  return null
}

export default DavidDefaultPromoBanner
